export default __webpack_public_path__ + "locales/fr/Payments.json?hash=62295bc07f65603133188f213cc4e67d";